import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function ProfileSubscription() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/profile/about/contact", { replace: true });
  }, [navigate]);

  return null;
}
